if (!customElements.get("featured-collections-slider")) {
  class FeaturedCollectionsSlider extends HTMLElement {
    constructor() {
      super();

      this.isDown = false;
      this.startX = 0;
      this.scrollLeftStart = 0;
      this.hasMoved = false;
    }

    connectedCallback() {
      const columns = parseInt(this.getAttribute("js-columns"), 10) || 0;

      if (columns <= 3) return;

      this.nextArrow = this.closest('.featured-collections').querySelector(".slider-arrow--next");
      this.prevArrow = this.closest('.featured-collections').querySelector(".slider-arrow--prev");

      if (this.prevArrow && this.nextArrow) {
        this.prevArrow.addEventListener("click", this.scrollPrev.bind(this));
        this.nextArrow.addEventListener("click", this.scrollNext.bind(this));
        this.addEventListener("scroll", this.updateArrowStates.bind(this));
        this.updateArrowStates();

        this.positionArrows();
    
        window.addEventListener('resize', this.positionArrows.bind(this));
      }

      this.addEventListener("mousedown", this.onMouseDown.bind(this));
      this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
      this.addEventListener("mouseup", this.onMouseUp.bind(this));
      this.addEventListener("mousemove", this.onMouseMove.bind(this));

      this.addEventListener("touchstart", this.onTouchStart.bind(this), { passive: false });
      this.addEventListener("touchmove", this.onTouchMove.bind(this), { passive: false });
      this.addEventListener("touchend", this.onTouchEnd.bind(this));
      this.addEventListener("touchcancel", this.onTouchEnd.bind(this));

      this.addEventListener('click', (e) => {
        if (this.hasMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    positionArrows() {
      const firstSlide = this.children[0];
      if (!firstSlide) return;
      
      const img = firstSlide.querySelector('img');
      if (!img) return;
      
      const imgRect = img.getBoundingClientRect();
      const containerRect = this.getBoundingClientRect();
      const imgCenter = imgRect.top - containerRect.top + (imgRect.height / 2);
      
      if (this.prevArrow && this.nextArrow) {
        this.prevArrow.style.top = `${imgCenter}px`;
        this.nextArrow.style.top = `${imgCenter}px`;
      }
    }

    scrollPrev() {
      const items = Array.from(this.children);
      const containerLeft = this.getBoundingClientRect().left;
      
      let currentIndex = items.findIndex(item => {
        const itemLeft = item.getBoundingClientRect().left;
        return itemLeft >= containerLeft - 1;
      });
      
      if (currentIndex > 0) {
        const targetItem = items[currentIndex - 1];
        const targetScroll = targetItem.offsetLeft - targetItem.parentElement.offsetLeft;
        this.scrollTo({ left: targetScroll, behavior: "smooth" });
      }
    }
    
    scrollNext() {
      const items = Array.from(this.children);
      const containerLeft = this.getBoundingClientRect().left;
      
      let currentIndex = items.findIndex(item => {
        const itemLeft = item.getBoundingClientRect().left;
        return itemLeft >= containerLeft - 1;
      });
      
      if (currentIndex !== -1 && currentIndex < items.length - 1) {
        const targetItem = items[currentIndex + 1];
        const targetScroll = targetItem.offsetLeft - targetItem.parentElement.offsetLeft;
        this.scrollTo({ left: targetScroll, behavior: "smooth" });
      }
    }

    updateArrowStates() {
      if (!this.prevArrow || !this.nextArrow) return;

      this.prevArrow.disabled = this.scrollLeft <= 0;

      const maxScroll = this.scrollWidth - this.clientWidth;
      this.nextArrow.disabled = this.scrollLeft >= maxScroll - 1;
    }

    onMouseDown(e) {
      this.isDown = true;
      this.hasMoved = false;
      this.startX = e.pageX - this.offsetLeft;
      this.scrollLeftStart = this.scrollLeft;
      e.preventDefault();
    };

    onMouseLeave() {
      this.isDown = false;
    }

    onMouseUp() {
      this.isDown = false;
    }

    onMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.offsetLeft;
      const walk = x - this.startX;
      this.scrollLeft = this.scrollLeftStart - walk;
      if (Math.abs(walk) > 5) {
        this.hasMoved = true;
      }
    }

    onTouchStart(e) {
      this.isDown = true;
      this.startX = e.touches[0].pageX - this.offsetLeft;
      this.scrollLeftStart = this.scrollLeft;
    }

    onTouchMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.touches[0].pageX - this.offsetLeft;
      const walk = x - this.startX;
      this.scrollLeft = this.scrollLeftStart - walk;
    }

    onTouchEnd() {
      this.isDown = false;
    }
  }

  customElements.define(
    "featured-collections-slider",
    FeaturedCollectionsSlider
  );
}
